import React from "react"
import { useEffect, useState } from "react"
import store, { type RootState } from "../../../global/config/store.ts"
import { Autocomplete, Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, FormGroup, Grid, IconButton, Stack, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography, } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { ApiGetAllRoles, ApiGetClientEntityByClientGroupId, ApiGetVenueList, ApiCreateEmailPreference, ApiGetEmailPreference, ApiDeleteEmailPreference, ApiUpdateEmailPreference, ApiImportEmailPreference } from "../../../apiService/Core/Apicall.tsx";
import useDebounce from "../CreateAllocations/UseDebounce.tsx";
import { toast } from "react-toastify";
import { setSelectedClientGroup } from "../../../global/config/Reducer/clientSlice.ts";
import { DescriptionOutlined, FileUploadOutlined, InsertDriveFileOutlined, PictureAsPdfOutlined } from '@mui/icons-material';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import { setLoadingFalse, setLoadingTrue } from "../../../global/config/Action/loadingActions.ts";



const EmailPreference: React.FC = () => {
    const selectedClientName = useSelector((state: RootState) => state.client.selectedClient)
    const dispatch = useDispatch()
    const Clientlist = useSelector((state: RootState) => state.client.clientList);
    const [selectedClient, setSelectedClient] = useState<any>(selectedClientName);
    const [ClientId, setClientId] = useState(null);
    const [clientEntityList, setClientEntityList] = useState<any>([]);
    const [clientEntityId, setClientEntityId] = useState<string | null>(null);
    const [open, setOpen] = useState(false);
    const [openEmail, setOpenEmail] = useState(false);
    const [venueName, setVenueName] = useState([]);
    const [venueNameValue, setVenueNameValue] = useState<any>(null);
    const [venus, setVenus] = useState([]);
    const debouncedClientEntityId = useDebounce(clientEntityId, 500);
    const [selectedVenues, setSelectedVenues] = useState<any[]>([]);
    const [selectAllVenues, setSelectAllVenues] = useState(false);
    const [roles, setRoles] = useState<any>([]);
    const [selectedRole, setSelectedRole] = useState<any>(null);
    const [approve, setApprove] = useState(false);
    const [release, setRelease] = useState(false);
    const [preferenceEmail, setPreferenceEmail] = useState("");
    const [emailData, setemailData] = useState<any[]>([]);
    // For Filtering (GET)
    const [filterRole, setFilterRole] = useState<any>(null);
    const [filterVenue, setFilterVenue] = useState<any>(null);
    // For Creating (POST)
    const [createRole, setCreateRole] = useState<any>(null);
    const [createVenues, setCreateVenues] = useState<any[]>([]);
    const [uploadedFiles, setUploadedFiles] = useState<string[]>([]);
    const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
    const [dialogClient, setDialogClient] = useState<any>(null);
    const [dialogEntityId, setDialogEntityId] = useState<any>(null);
    const [dialogEntityList, setDialogEntityList] = useState<any>([]);
    const [selectAllApprove, setSelectAllApprove] = useState(false);
    const [selectAllRelease, setSelectAllRelease] = useState(false);


    console.log("Selected Venues", createVenues)
    useEffect(() => {
        if (Clientlist.length > 2) {
            // setSelectedClient(Clientlist[2])
            setClientId(Clientlist[2].clientGroupName)
        }
    }, [Clientlist])

    useEffect(() => {
        setSelectedClient(selectedClientName)
    }, [selectedClientName])

    useEffect(() => {
        if (selectedClient?.clientGroupName) {
            handleGetClientList()
        }
    }, [selectedClient?.clientGroupName])

    useEffect(() => {
        if (clientEntityList.length > 0 && !clientEntityId) {
            setClientEntityId(clientEntityList[0].clientEntityId);
        }
    }, [clientEntityList]);
    const handleGetClientList = async () => {
        const data = `?ClientGroupName=${selectedClientName?.clientGroupName}`
        if (!selectedClient?.clientGroupName) return
        try {
            const res: any = await ApiGetClientEntityByClientGroupId(data)
            setClientEntityList(res.data)
        } catch (error) {
            console.error("Error during API call:", error)
        }
    }
    const handleClose = () => setOpen(false)
    const ApiCallGetVenueList = async (debouncedClientEntityId?: any) => {
        const data = `?clientEntityId=${clientEntityId}&offset=0&limit=500&venueStatus=active`
        const res = await ApiGetVenueList(data)
        setVenus(res?.data)
        const response = res?.data.map((item) => ({
            label: item.venueName,
            value: item.venueId,
        }))
        setVenueName(response)
    }
    const handleCloseEmail = () => {
        setOpenEmail(false);
        setUploadedFiles([]);
        setSelectedFiles([]);
        setCreateVenues([])
        setSelectedVenues([])
        setSelectAllVenues(false)
    };
    useEffect(() => {
        if (debouncedClientEntityId) {
            ApiCallGetVenueList(debouncedClientEntityId)
        } else {
            setVenueName([])
            setVenueNameValue(null)
        }
    }, [debouncedClientEntityId])

    useEffect(() => {
        if (clientEntityId === null) {
            setVenueName([])
        }
    }, [clientEntityId])
    const handleSelectAllVenues = (event: React.ChangeEvent<HTMLInputElement>) => {
        const checked = event.target.checked
        const allVenueIds = venueName.map(v => v.value);
        setSelectAllVenues(checked);
        setSelectedVenues(checked ? allVenueIds : []);
        setCreateVenues(checked ? allVenueIds : []);
    }
    const handleVenueToggle = (venueId: number) => {
        setSelectedVenues((prev) => {
            const updated = prev.includes(venueId)
                ? prev.filter(id => id !== venueId)
                : [...prev, venueId];
            setCreateVenues(updated);
            return updated;
        });
    };

    const handleGetApiCallRoles = async () => {
        const data: any = {}
        try {
            const response: any = await ApiGetAllRoles(data)
            setRoles(response.data)
        } catch (error) {
            console.error('Error during API call:', error)
            toast.error('Error On fetching Roles List!')
        }
    }
    useEffect(() => {
        handleGetApiCallRoles();
        console.log(roles);

    }, []);
    const allowedRoleIds = [5, 6, 9];
    const filteredRoles = roles
        .filter(role => allowedRoleIds.includes(role.roleId))
        .map(role => ({
            label: role.roleDisplayName,
            value: role.roleId
        }));
    const handleCreateEmailPreference = async () => {
        if (!filteredRoles) {
            toast.error("Please select a role.");
            return;
        }
        if (filterVenue?.length === 0) {
            toast.error("Please select at least one venue.");
            return;
        }
        if (!preferenceEmail.trim()) {
            toast.error("Please enter an email.");
            return;
        }

        const data = {
            // venueIds: createVenues.join(","),
            roleId: createRole,
            isReportApprove: approve,
            isReportRelease: release,
            email: preferenceEmail.trim(),
            clientEntityId: clientEntityId,
            ...(createVenues?.length > 0 && { venueIds: createVenues.join(",") }),
        };

        try {
            const res = await ApiCreateEmailPreference(data);
            console.log("Creating res", res.data);
            toast.success("Email Preference Created Successfully.");

            // reset
            setOpen(false);
            setSelectedRole(null);
            setSelectedVenues([]);
            setCreateVenues([]);
            setSelectAllVenues(false)
            setApprove(false);
            setRelease(false);
            setPreferenceEmail("");
            handleGetPreference();
        } catch (error) {
            console.error("Error during API call:", error);
            toast.error("Error Creating Email Preference.");
        }
    }
    const handleGetPreference = async () => {
        if(!clientEntityId) return;
        try {
            const data = `?clientEntityId=${clientEntityId}${filterVenue !== null ? `&venueId=${filterVenue}` : ''}${filterRole !== null ? `&roleId=${filterRole}` : ''}`
            const res = await ApiGetEmailPreference(data);
            setemailData(res?.data);
            console.log("response of preference", res?.data);

        } catch (error) {
            console.error("Error Getting Email Preference.", error);
            toast.error("Error generating Email Preference.")
        }
    }
    useEffect(() => {
        handleGetPreference();
    }, [clientEntityId, filterVenue, filterRole]);
    const handleDelete = async (emailPreferenceId: number) => {
        try {
            const data = `?emailPreferenceId=${emailPreferenceId}`
            await ApiDeleteEmailPreference(data);
            handleGetPreference();
            toast.success("Email Preference Deleted Successfully.")
        } catch (error) {
            console.error("Error Deleting Email Preference.", error);
            toast.error("Error Deleting Preference.")
        }
    }
    const handleUpdateEmailPreference = async (
        emailPreferenceId: number,
        updateField: "isApprove" | "isRelease",
        newValue: boolean
    ) => {
        try {
            const payload = {
                emailPreferenceIds: [emailPreferenceId],
                [updateField]: newValue,
            };
            await ApiUpdateEmailPreference(payload);
            toast.success("Updated successfully.");
            handleGetPreference();
        } catch (error) {
            console.error("Update error:", error);
            toast.error("Failed to update preference.");
        }
    };

    const handleGetDialogClientEntities = async (clientGroupName: string) => {
        try {
            const data = `?ClientGroupName=${clientGroupName}`;
            const res: any = await ApiGetClientEntityByClientGroupId(data);
            setDialogEntityList(res.data);
        } catch (error) {
            console.error("Error fetching dialog client entities:", error);
        }
    };

    const handleRemoveFile = (index: number, isUploaded: boolean = true) => {
        if (isUploaded) {
            setUploadedFiles(prev => {
                const updatedFiles = [...prev];
                updatedFiles.splice(index, 1);
                return updatedFiles;
            });
        } else {
            setSelectedFiles(prev => {
                const updatedFiles = [...prev];
                updatedFiles.splice(index, 1);
                return updatedFiles;
            });
        }
    };
    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const files = event.target.files;
        if (files) {
            setSelectedFiles(Array.from(files));
        }
    };
    const handleImportEmailPreference = async () => {
        if (!dialogEntityId || selectedFiles.length === 0) {
            toast.error("Please select a client entity and upload a file");
            return;
        }

        try {
            const formData = new FormData();
            formData.append("clientEntityId", dialogEntityId);
            formData.append("file", selectedFiles[0]);

            store.dispatch(setLoadingTrue());
            await ApiImportEmailPreference(formData);

            toast.success("Email Preferences imported successfully!");
            handleCloseEmail();
            handleGetPreference();
        } catch (error: any) {
            console.error("Import failed:", error);
            toast.error(error?.response?.data?.message || "Failed to import Email Preference");
        } finally {
            store.dispatch(setLoadingFalse());
        }
    };

    useEffect(() => {
        if (emailData.length > 0) {
            const allApproved = emailData.every(email => email?.isReportApproveMailNeedtoSent);
            const allReleased = emailData.every(email => email?.isReportReleaseMailNeedtoSent);
            setSelectAllApprove(allApproved);
            setSelectAllRelease(allReleased);
        } else {
            setSelectAllApprove(false);
            setSelectAllRelease(false);
        }
    }, [emailData]);

    const handleSelectAllApprove = async (checked: boolean) => {
        if (emailData.length === 0) return;

        const emailPreferenceIds = emailData.map(email => email.emailPreferenceId);

        try {
            await ApiUpdateEmailPreference({
                emailPreferenceIds: emailPreferenceIds,
                isApprove: checked
            });
            toast.success("All approve preferences updated successfully.");
            handleGetPreference();
        } catch (error) {
            console.error("Update error:", error);
            toast.error("Failed to update approve preferences.");
        }
    };

    const handleSelectAllRelease = async (checked: boolean) => {
        if (emailData.length === 0) return;

        const emailPreferenceIds = emailData.map(email => email.emailPreferenceId);

        try {
            await ApiUpdateEmailPreference({
                emailPreferenceIds: emailPreferenceIds,
                isRelease: checked
            });
            toast.success("All release preferences updated successfully.");
            handleGetPreference();
        } catch (error) {
            console.error("Update error:", error);
            toast.error("Failed to update release preferences.");
        }
    };

    return (
        <Box className='w-100 p-2'>
            <Box className='w-100 p-2 py-3 border-10 bg-light'>
                <Stack spacing={3}>
                    <Box sx={{ width: "100%" }}>
                        <Typography className="fs-42 text-center" style={{ textAlign: "end" }}>
                            Email Preference
                        </Typography>
                        <Box
                            sx={{
                                display: "flex",
                                flexWrap: 'wrap',
                                alignItems: 'center',
                                gap: 2,
                                marginTop: "23px",
                            }}
                        >
                            <Box className='d-flex flex-wrap col-12 col-md-auto' gap={2}>
                                <Stack direction="row" width={{ xs: "100%", md: 180 }} spacing={1}>
                                    <FormControl size="small" sx={{ width: { xs: "100%", md: 180 } }}>
                                        <Autocomplete
                                            disablePortal
                                            id="mm-autocomplete"
                                            options={Clientlist}
                                            value={selectedClient}
                                            getOptionLabel={(option: any) => option?.clientGroupName}
                                            isOptionEqualToValue={(option: any, value: any) =>
                                                option.clientGroupDBName === value.clientGroupDBName
                                            }
                                            onChange={(event, newValue: any) => {
                                                // setSelectedClient(newValue)
                                                dispatch(setSelectedClientGroup(newValue))
                                                setClientId(newValue?.clientGroupName || null)
                                                // if (!newValue || (selectedClient && newValue.clientGroupName !== selectedClient.clientGroupName)) {
                                                    setClientEntityId(null)
                                                    setFilterVenue(null)
                                                    // setVenueNameValue(null)
                                                    setClientEntityList([])
                                                // }
                                            }}
                                            defaultValue="mmcommon"
                                            renderInput={(params) => <TextField {...params} label="Select Client" />}
                                            size="small"
                                        />
                                    </FormControl>
                                </Stack>
                                <Stack direction="row" width={{ xs: "100%", md: 180 }} spacing={1}>
                                    <FormControl size="small" sx={{ width: { xs: "100%", md: 180 } }}>
                                        <Autocomplete
                                            disablePortal
                                            id="beacon-autocomplete"
                                            options={clientEntityList?.filter((item) => item.clientEntityId !== null)}
                                            getOptionLabel={(option) => option?.entityName || ""}
                                            onChange={(event, newValue: any) => {
                                                setClientEntityId(newValue?.clientEntityId || null)
                                                setFilterVenue(null)
                                                // if (!newValue) {
                                                //     setVenueNameValue(null)
                                                // }
                                            }}
                                            value={clientEntityList?.find((option) => option?.clientEntityId === clientEntityId) || null}
                                            renderInput={(params) => <TextField {...params} label="Select Business" />}
                                            size="small"
                                        />
                                    </FormControl>
                                </Stack>
                                <Stack direction="row" width={{ xs: "100%", md: 180 }} spacing={1}>
                                    <FormControl size="small" sx={{ width: { xs: "100%", md: 180 } }}>
                                        <Autocomplete
                                            disablePortal
                                            id="mm-autocomplete"
                                            options={venueName}
                                            value={venueName.find((option: any) => option.value === filterVenue) || null}
                                            onChange={(event, newValue: any) => {
                                                setFilterVenue(newValue?.value || null)
                                            }}
                                            defaultValue=""
                                            renderInput={(params) => <TextField {...params} label="Search By Venue" />}
                                            size="small"
                                        />
                                    </FormControl>
                                </Stack>
                                <Stack direction="row" width={{ xs: "100%", md: 180 }} spacing={1}>
                                    <FormControl size="small" sx={{ width: { xs: "100%", md: 180 } }}>
                                        <Autocomplete
                                            disablePortal
                                            id="mm-autocomplete"
                                            options={filteredRoles}
                                            value={filteredRoles.find((role) => role.value === filterRole) || null}
                                            onChange={(event, newValue: any) => {
                                                setFilterRole(newValue?.value || null);
                                            }}
                                            getOptionLabel={(option: any) => option.label}
                                            isOptionEqualToValue={(option, value) => option.value === value.value}
                                            renderInput={(params) => <TextField {...params} label="Search By Role" />}
                                            size="small"
                                        />
                                    </FormControl>
                                </Stack>
                            </Box>
                            <Box className='col-12 col-md-auto' sx={{ display: "grid", gap: "20px", marginLeft: "auto" }}>
                                <Box sx={{ marginLeft: "auto", display: "flex", gap: 2 }}>
                                    <Button variant="contained" className="table-row-background"
                                        onClick={() => setOpenEmail(true)}
                                    >
                                        Import Email Preferences
                                    </Button>
                                    <Button variant="contained" className="table-row-background"
                                        onClick={() => {
                                            if (!clientEntityId) {
                                                toast.warn("Please select a business before adding new preference.");
                                                return;
                                            }
                                            setOpen(true);
                                        }}
                                    >
                                        Add New
                                    </Button>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                </Stack>
                <Dialog open={open} onClose={handleClose}>
                    <DialogTitle style={{ textAlign: "center" }}>Add New Email Preference</DialogTitle>
                    <DialogContent>
                        <div className="form-group mb-0" style={{ marginTop: "20px" }}>
                            <FormControl size="small" sx={{ width: '100%', marginBottom: '20px' }}>
                                <Autocomplete
                                    disablePortal
                                    id="mm-autocomplete"
                                    options={filteredRoles}
                                    value={filteredRoles.find((role) => role.value === createRole) || null}
                                    onChange={(event, newValue: any) => {
                                        setCreateRole(newValue?.value || null);
                                    }}
                                    getOptionLabel={(option: any) => option.label}
                                    isOptionEqualToValue={(option, value) => option.value === value.value}
                                    renderInput={(params) => <TextField {...params} label="Select Role" />}
                                    size="small"
                                />
                            </FormControl>
                            <FormControl component="fieldset" sx={{ width: '100%' }}>
                                <FormGroup>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={selectAllVenues}
                                                onChange={handleSelectAllVenues}
                                            />
                                        }
                                        label="Select All Venues"
                                    />
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                                        {venueName.map((venue: any) => (
                                            <Box
                                                key={venue.value}
                                                sx={{
                                                    width: 'calc(50% - 8px)',
                                                    boxSizing: 'border-box',
                                                }}
                                            >
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={createVenues.includes(venue.value)}
                                                            onChange={() => handleVenueToggle(venue.value)}
                                                        />
                                                    }
                                                    label={venue.label}
                                                />
                                            </Box>
                                        ))}
                                    </Box>
                                </FormGroup>
                            </FormControl>
                            <TextField
                                label="Enter Your Preference Email"
                                fullWidth
                                size="small"
                                sx={{ marginTop: '20px' }}
                                value={preferenceEmail}
                                onChange={(e) => setPreferenceEmail(e.target.value)}
                            />
                            <Box sx={{ display: 'flex', marginTop: 2, gap: 2 }}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={approve}
                                            onChange={(e) => setApprove(e.target.checked)}
                                        />
                                    }
                                    label="Approve"
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={release}
                                            onChange={(e) => setRelease(e.target.checked)}
                                        />
                                    }
                                    label="Release"
                                />
                            </Box>
                        </div>
                    </DialogContent>
                    <DialogActions sx={{ justifyContent: 'space-between', marginLeft: 2, marginRight: 2 }}>
                        <Button
                            variant="outlined"
                            sx={{ color: '#75724C', borderColor: '#75724C', width: '100%' }}
                            onClick={() => {
                                setOpen(false)
                                setCreateVenues([])
                                setSelectedVenues([])
                                setSelectAllVenues(false)
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="contained"
                            color="primary"
                            className='table-row-background'
                            sx={{ width: '100%' }}
                            onClick={() => {
                                handleCreateEmailPreference();
                            }}
                        >
                            Add
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog open={openEmail} onClose={handleCloseEmail} PaperProps={{
                    sx: {
                        width: '900px',
                        height: 'fit-content',
                        maxWidth: 'none'
                    }
                }}>
                    <DialogContent>
                        <Typography variant="h6" gutterBottom>
                            Import Email Preference
                        </Typography>

                        <FormControl fullWidth size="small" className="mb-3">
                            <Autocomplete
                                disablePortal
                                options={Clientlist}
                                value={dialogClient}
                                getOptionLabel={(option) => option?.clientGroupName || ""}
                                isOptionEqualToValue={(option, value) =>
                                    option.clientGroupDBName === value.clientGroupDBName
                                }
                                onChange={(event, newValue: any) => {
                                    setDialogClient(newValue);
                                    setDialogEntityId(null);
                                    setDialogEntityList([]);
                                    if (newValue?.clientGroupName) {
                                        handleGetDialogClientEntities(newValue.clientGroupName);
                                    }
                                }}

                                renderInput={(params) => (
                                    <TextField {...params} label="Select Client" />
                                )}
                            />
                        </FormControl>

                        <FormControl fullWidth size="small" className="mb-3">
                            <Autocomplete
                                disablePortal
                                options={dialogEntityList.filter((item) => item.clientEntityId !== null)}
                                getOptionLabel={(option) => option?.entityName || ""}
                                value={
                                    dialogEntityList.find((option) => option?.clientEntityId === dialogEntityId) || null
                                }
                                onChange={(event, newValue: any) =>
                                    setDialogEntityId(newValue?.clientEntityId || null)
                                }
                                renderInput={(params) => (
                                    <TextField {...params} label="Select Business" />
                                )}
                            />
                        </FormControl>
                        <FormControl className='mt-3' fullWidth>
                            <Grid container className='w-100' spacing={2}>
                                {selectedFiles.map((file, index) => (
                                    <Grid size={12} key={index}>
                                        <Box
                                            className='w-100'
                                            sx={{
                                                position: 'relative',
                                                border: '1px solid',
                                                borderRadius: '20px',
                                                overflow: 'hidden',
                                                height: '150px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                flexDirection: 'column',
                                                p: 2
                                            }}
                                        >
                                            {file.name.endsWith(".pdf") ? (
                                                <PictureAsPdfOutlined color="error" fontSize="large" />
                                            ) : file.name.endsWith(".xlsx") || file.name.endsWith(".xls") ? (
                                                <DescriptionOutlined color="success" fontSize="large" />
                                            ) : (
                                                <InsertDriveFileOutlined color="action" fontSize="large" />
                                            )}

                                            <Typography variant="body2" noWrap sx={{ maxWidth: '100%', mt: 1 }}>
                                                {file.name}
                                            </Typography>

                                            <IconButton
                                                onClick={() => handleRemoveFile(index, false)}
                                                sx={{
                                                    position: 'absolute',
                                                    top: 5,
                                                    right: 5,
                                                    bgcolor: 'white',
                                                    '&:hover': { bgcolor: 'grey.100' },
                                                }}
                                            >
                                                <CancelOutlinedIcon color="error" />
                                            </IconButton>
                                        </Box>
                                    </Grid>
                                ))}

                                {selectedFiles.length < 1 && (
                                    <Grid size={12}>
                                        <label htmlFor="file-upload" className="w-100" style={{ fontSize: '14px', color: 'grey' }}>
                                            Upload Files
                                            <Box
                                                className="mt-2 w-100 d-flex align-items-center justify-content-center"
                                                height={150}
                                                border="1px dashed #00000033"
                                                borderRadius={5}
                                            >
                                                <input
                                                    type="file"
                                                    id="file-upload"
                                                    accept=".pdf,.xlsx,.xls,.doc,.docx,.txt,.csv"
                                                    style={{ display: "none" }}
                                                    onChange={handleFileChange}
                                                    multiple
                                                />
                                                <Box className="d-flex flex-column align-items-center justify-content-center">
                                                    <Box className="border-blue" borderRadius="10px">
                                                        <FileUploadOutlined fontSize="medium" className="text-blue" />
                                                    </Box>
                                                    <Typography variant="caption">Upload Here</Typography>
                                                </Box>
                                            </Box>
                                        </label>
                                    </Grid>
                                )}
                            </Grid>
                        </FormControl>

                        <DialogActions>
                            <Stack direction="row" spacing={2} justifyContent="flex-end" mt={3}>
                                <Button
                                    variant="contained"
                                    onClick={() => handleCloseEmail()}
                                    className="table-row-background "
                                >
                                    Cancel
                                </Button>
                                <Button
                                    variant="contained"
                                    onClick={() => handleImportEmailPreference()}
                                    className="table-row-background "
                                >
                                    Submit
                                </Button>
                            </Stack>
                        </DialogActions>
                    </DialogContent>
                </Dialog>
                <Box className='w-100' overflow={'auto'} sx={{ marginTop: 4 }}>
                    <Table>
                        <TableHead>
                            <TableRow sx={{ backgroundColor: "#75724C" }}>
                                <TableCell sx={{ color: "#fff" }}></TableCell>
                                <TableCell sx={{ color: "#fff" }}>Site No</TableCell>
                                <TableCell sx={{ color: "#fff" }}>Site Name</TableCell>
                                <TableCell sx={{ color: "#fff" }}>Type</TableCell>
                                <TableCell sx={{ color: "#fff" }}>Email</TableCell>
                                <TableCell sx={{ color: "#fff", textAlign: 'center' }}>
                                    <Checkbox
                                        checked={selectAllApprove}
                                        onChange={(e) => handleSelectAllApprove(e.target.checked)}
                                        sx={{ color: "#fff", '&.Mui-checked': { color: "#fff" } }}
                                    />
                                    Approve
                                </TableCell>
                                <TableCell sx={{ color: "#fff", textAlign: 'center' }}>
                                    <Checkbox
                                        checked={selectAllRelease}
                                        onChange={(e) => handleSelectAllRelease(e.target.checked)}
                                        sx={{ color: "#fff", '&.Mui-checked': { color: "#fff" } }}
                                    />
                                    Release
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {emailData.map((email) => (
                                <TableRow key={''} sx={{ borderBottom: "1px solid #c0bfa2" }}>
                                    <TableCell>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            className='table-row-background'
                                            onClick={() => {
                                                handleDelete(email?.emailPreferenceId)
                                            }}
                                        >
                                            Delete
                                        </Button>
                                    </TableCell>
                                    <TableCell>{email?.venueId?.venueNumber}</TableCell>
                                    <TableCell>{email?.venueId?.venueName}</TableCell>
                                    <TableCell>{email?.roleId?.roleDisplayName}</TableCell>
                                    <TableCell>{email?.emailId}</TableCell>
                                    <TableCell align="center">
                                        <Checkbox
                                            checked={email?.isReportApproveMailNeedtoSent}
                                            onChange={(e) =>
                                                handleUpdateEmailPreference(
                                                    email?.emailPreferenceId,
                                                    "isApprove",
                                                    e.target.checked
                                                )
                                            }
                                        />
                                    </TableCell>
                                    <TableCell align="center">
                                        <Checkbox
                                            checked={email?.isReportReleaseMailNeedtoSent}
                                            onChange={(e) =>
                                                handleUpdateEmailPreference(
                                                    email?.emailPreferenceId,
                                                    "isRelease",
                                                    e.target.checked
                                                )
                                            }
                                        />
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </Box>
            </Box>
        </Box>
    )
}
export default EmailPreference;